import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  EventEmitter,
  Output,
} from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatPaginator
} from '@angular/material';

import { FormBuilder, FormGroup, Validator } from '@angular/forms';
import { DragAndDropUploadComponent } from "./../drag-and-drop-upload/drag-and-drop-upload.component";

@Component({
  selector: 'app-uploaddialog',
  templateUrl: './uploaddialog.component.html',
  styleUrls: ['./uploaddialog.component.scss']
})

export class UploadDialogComponent implements OnInit {

  formDoc: FormGroup;

  fdate: string;
  uploadTypes: any;
  basicfile: string;
  allowUpload: boolean;
  uploadFileType: string;
  fdesc: string;
  ftype: string;
  files: Object;
  type: string;
  description: string;
  caseName: string;
  creator: any;

  action_params: any;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  @Output() onFinish = new EventEmitter();
  onFileSelection = new EventEmitter();
  onUploadTypeSelection = new EventEmitter();
  dragAndDropControl: boolean;
  dragMessage: string;
  uploadType: string;
  allowFolderUpload: boolean;

  constructor(

    private fb: FormBuilder,
    private dialogRef: MatDialogRef<UploadDialogComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.uploadTypes = data.uploadTypes;
    this.fdate = data.fdate;
    this.basicfile = data.basicfile;
    this.caseName = data.action_params.caseName;
    this.creator = data.action_params.creator;

    this.files = {};
    this.fdesc = '';
    this.ftype = '';

    this.action_params = data.action_params;

    this.formDoc = this.fb.group({
      description: [this.description, []],
      uploadTypes: [this.uploadTypes, []],
      fdate: [this.fdate, []],
      fdesc: [this.fdesc, []],
      basicfile: [this.basicfile, []],
      files: [this.files, []]
    })

    this.dragAndDropControl = false;
  }

  handleUploadTypeSelection(event: Event): void {
    let dd_value = (<HTMLSelectElement>event.target).value;
    if (dd_value) {
      this.allowUpload = true;
    }

    switch (dd_value) {
      case '1':
        this.allowFolderUpload = false
        break;
      case '2':
        this.allowFolderUpload = false
        break;
      case '3':
        this.dragAndDropControl = true
        this.dragMessage = "Drag your DICOM Disk (medical images) here"
        this.allowFolderUpload = true
        this.uploadType = 'DICOM'
        break;
      case '4':
        this.dragAndDropControl = true
        this.dragMessage = "Drag your Video Disk here"
        this.allowFolderUpload = true
        this.uploadType = 'video'
        break;
      default:
        this.dragAndDropControl = false
        break;
    }
  }

  handleFileSelection(event: Event): void {
    this.files = (<HTMLInputElement>event.target).files;
    this.saveAndClose(<FileList>this.files)
  }

  ngOnInit(): void {
  }

  onSubmit() {
    console.log('SUBMITTED', this.formDoc);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  save() {
    this.dialogRef.close(this.formDoc.value);
  }

  saveAndClose(files: FileList) {
    this.onFinish.emit({
      files: files,
      desc: this.fdesc,
      type: this.ftype,
      fdate: this.fdate,
      caseName: this.caseName,
      creator: this.creator
    })
    this.dialogRef.close();
  }

  saveDateChild() {
    console.log("SaveDateChild");
  }

  close() {
    this.dialogRef.close();
  }
}